module.exports = __webpack_public_path__ + "static/media/MY-JILONGPO.a427bc41.jpg";